import React, { Component } from 'react';
import { connect } from 'react-redux';
import FullScreen from 'react-request-fullscreen';
import * as mediaActions from '../../store/media/actions';
import * as reducers from '../../store/reducers';
import RampUnit from '../../utils/Playwire/RampUnit';

import BookTurnButton from 'Components/BookTurnButton';
import styles from './BookReaderV2.scss';
import sliderStyles from './BookPageSlider.scss';
import Button from 'Components/Button';
import EnterFullscreenIcon from './fullscreenicon.svg';
import ExitFullscreenIcon from './exitfullscreenicon.svg';

import { withLocationWrapper } from '../../utils/HOC_LocationWrapper';


class BookReaderV2 extends Component {
  constructor(props) {
    super(props);

    this.onPageTurn = this.onPageTurn.bind(this);
    this.goToPage = this.goToPage.bind(this);
    this.getActivePage = this.getActivePage.bind(this);
    this.onKeyup = this.onKeyup.bind(this);
    this.onFullScreenChange = this.onFullScreenChange.bind(this);
    this.requestOrExitFullScreen = this.requestOrExitFullScreen.bind(this);
    this.state = {
      isRangeFocused: false,
      isFullScreen: false,
    };
  }

  loadData() {
    const { dataURI, slug, fetchBookData } = this.props;
    fetchBookData(dataURI.replace('content.', 'www.'), slug);
  }

  getActivePage() {
    const { params, bookData } = this.props;
    const activePage =
      params.pageID && bookData && bookData.pages[params.pageID]
        ? params.pageID
        : undefined;
    return parseInt(activePage, 10);
  }

  componentDidMount() {
    this.loadData();
    window.addEventListener('keyup', this.onKeyup, false);
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.onKeyup, false);
  }

  onKeyup(e) {
    if (e.key === 'ArrowRight') this.onPageTurn(e, 'next');
    if (e.key === 'ArrowLeft') this.onPageTurn(e, 'previous');
  }

  componentDidUpdate(prevProps) {
    const { params, bookData } = this.props;
    if (params.bookID !== prevProps.params.bookID) {
      this.loadData();
    }
    const activePage = this.getActivePage();
    if (!activePage && bookData) {
      this.goToPage(1);
    }
  }

  goToPage(pageNumber) {
    const { params, navigate } = this.props;
    navigate(`/books/${params.bookID}/page/${pageNumber}`);
  }

  onPageTurn(event, direction) {
    if (this.state.isRangeFocused) {
      return;
    }
    event.preventDefault();
    let newPage = this.getActivePage();
    newPage = direction === 'next' ? newPage + 1 : newPage - 1;
    this.props.refreshAds();
    this.goToPage(newPage);
  }

  onFullScreenChange(isFullScreen) {
    this.setState({ isFullScreen });
  }

  requestOrExitFullScreen() {
    this.fullScreenRef.fullScreen(this.readerEl);
  }

  render() {
    const { bookData, dataURI } = this.props;
    if (!dataURI) return <div>Book not found</div>;

    const { isFullScreen } = this.state;
    const activePage = this.getActivePage();

    if (!bookData || !activePage) {
      return <div>Loading...</div>;
    }

    const { pages } = bookData;
    const getImageUri = pageNumber => {
      const imageFile = pages[pageNumber];
      return `${dataURI.replace('content.', 'www.')}pages/${imageFile}`;
    };
    const pageKeys = Object.keys(pages);
    const totalPages = pageKeys.length;
    const imageURI = getImageUri(activePage);
    const nextImageURI = getImageUri(activePage + 1);

    const allowNext = pageKeys.includes((activePage + 1).toString());
    const allowPrevious = pageKeys.includes((activePage - 1).toString());

    return (
      <FullScreen
        ref={ref => {
          this.fullScreenRef = ref;
        }}
        onFullScreenChange={this.onFullScreenChange}
      >
        <div
          className={`BookReaderV2 ${
            isFullScreen ? 'BookReaderV2--FullScreen' : ''
          }`}
          ref={div => {
            this.readerEl = div;
          }}
        >
          {isFullScreen && (
            <aside className="BookReaderV2__AdContainer BookReaderV2__AdContainer--left">
              <RampUnit type="med_rect_atf" id="siderec" />
            </aside>
          )}
          <div className="BookReaderV2__PageContainer">
            <div className="BookReaderV2__PageContainer__Page--hidden">
              <img alt="next page" src={nextImageURI} />
            </div>
            <div className="BookReaderV2__PageContainer__Page">
              <img
                role="button"
                alt={`page ${activePage}`}
                className={`BookReaderV2__PageContainer__Page__Image ${
                  allowNext
                    ? 'BookReaderV2__PageContainer__Page__Image--allow-next'
                    : ''
                }`}
                src={imageURI}
                onKeyDown={() => {}}
                onClick={e => {
                  if (allowNext) {
                    this.onPageTurn(e, 'next');
                  }
                }}
              />
            </div>
            <div className="BookReaderV2__ControlsWrapper">
              <div className="BookReaderV2__ControlsWrapper__Controls">
                <BookTurnButton
                  onPageTurn={e => this.onPageTurn(e, 'previous')}
                  direction="previous"
                  allow={allowPrevious}
                />
                <div className="BookReaderV2__ControlsWrapper__Controls__Status">
                  <div>
                    Page {activePage} of {totalPages}
                  </div>
                  <div>
                    <input
                      className="BookPageSlider"
                      onFocus={() => {
                        this.setState({ isRangeFocused: true });
                      }}
                      onBlur={() => {
                        this.setState({ isRangeFocused: false });
                      }}
                      onChange={e => {
                        this.goToPage(e.target.value);
                      }}
                      type="range"
                      min={1}
                      max={totalPages}
                      value={activePage}
                    />
                  </div>
                </div>
                <BookTurnButton
                  onPageTurn={e => this.onPageTurn(e, 'next')}
                  direction="next"
                  allow={allowNext}
                />
              </div>
            </div>
            <div className="BookReaderV2__FullScreenButtonWrapper">
              <Button
                text={
                  isFullScreen ? (
                    <span title="Exit Fullscreen">
                      <ExitFullscreenIcon />
                    </span>
                  ) : (
                    <span title="Fullscreen">
                      <EnterFullscreenIcon />
                    </span>
                  )
                }
                clickHandler={this.requestOrExitFullScreen}
              />
            </div>
          </div>
          {isFullScreen && (
            <aside className="BookReaderV2__AdContainer BookReaderV2__AdContainer--right">
              <RampUnit type="med_rect_btf" id="sideflex" />
            </aside>
          )}
        </div>
      </FullScreen>
    );
  }
}

const mapStateToProps = (state, { params }) => {
  const slug = params.bookID;
  return {
    bookData: reducers.getBookData(state, slug),
    errorMessage: reducers.getErrorMessage(state),
  };
};

const BookReaderV2Component = connect(mapStateToProps, mediaActions)(BookReaderV2);

export default withLocationWrapper(BookReaderV2Component);
